import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LoadingOverlay = ({ isLoading = true }) => {
    if (!isLoading)
        return null;
    return (_jsx("div", { style: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(248, 252, 255, 0.99)', // #F8FCFF with 85% opacity
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
        }, children: _jsxs("div", { style: { textAlign: 'center', color: '#fff' }, children: [_jsxs("div", { style: {
                        position: 'relative',
                        width: '120px',
                        height: '120px',
                        margin: '0 auto 20px auto',
                    }, children: [_jsx("div", { style: {
                                position: 'absolute',
                                bottom: '20px',
                                left: '35px',
                                width: '50px',
                                height: '70px',
                                background: '#a9a9a9', // Slightly lighter gray for realism
                                border: '3px solid #d3d3d3', // Softer white border
                                borderRadius: '4px',
                                boxShadow: 'inset 0 2px 5px rgba(0,0,0,0.2), 0 2px 4px rgba(0,0,0,0.3)', // Inner shadow for depth
                                animation: 'tabletShake 1.5s infinite',
                                backgroundImage: 'linear-gradient(to bottom, transparent 20px, #777 20px, #777 22px, transparent 22px, transparent 40px, #777 40px, #777 42px, transparent 42px), radial-gradient(circle, rgba(255,255,255,0.15) 20%, transparent 60%)', // Subtle texture
                            } }), _jsx("div", { style: {
                                position: 'absolute',
                                bottom: '60px',
                                left: '40px',
                                width: '30px',
                                height: '30px',
                                animation: 'splashAppear 2s infinite',
                                opacity: 0,
                            }, children: _jsx("div", { style: {
                                    position: 'absolute',
                                    width: '100%',
                                    height: '100%',
                                    background: 'radial-gradient(circle, rgba(169, 169, 169, 0.8) 0%, rgba(255,255,255,0) 90%)', // Gray dust splash
                                    borderRadius: '50%',
                                    transform: 'scale(0.2)',
                                    animation: 'splashGrow 0.3s infinite',
                                    animationDelay: '0.2s',
                                } }) }), _jsxs("div", { style: {
                                position: 'absolute',
                                bottom: '60px',
                                left: '45px',
                                animation: 'dustAppear 1.5s infinite',
                                opacity: 0,
                            }, children: [_jsx("div", { style: {
                                        position: 'absolute',
                                        width: '20px',
                                        height: '20px',
                                        background: 'rgba(200, 200, 200, 0.7)', // Lighter dust
                                        borderRadius: '50%',
                                        left: '0px',
                                        top: '0px',
                                        animation: 'dustFloat1 1.5s infinite',
                                    } }), _jsx("div", { style: {
                                        position: 'absolute',
                                        width: '10px',
                                        height: '10px',
                                        background: 'rgba(200, 200, 200, 0.7)',
                                        borderRadius: '50%',
                                        left: '8px',
                                        top: '-3px',
                                        animation: 'dustFloat2 1.5s infinite',
                                    } }), _jsx("div", { style: {
                                        position: 'absolute',
                                        width: '3px',
                                        height: '3px',
                                        background: 'rgba(200, 200, 200, 0.7)',
                                        borderRadius: '50%',
                                        left: '-5px',
                                        top: '5px',
                                        animation: 'dustFloat3 1.5s infinite',
                                    } }), _jsx("div", { style: {
                                        position: 'absolute',
                                        width: '4px',
                                        height: '4px',
                                        background: '#d3d3d3', // Subtle spark
                                        borderRadius: '50%',
                                        left: '2px',
                                        top: '-5px',
                                        animation: 'sparkFloat1 1.5s infinite',
                                    } })] }), _jsx("div", { style: {
                                position: 'absolute',
                                top: '30px',
                                left: '95px',
                                width: '12px',
                                height: '40px',
                                background: 'linear-gradient(to right, #6b3c1f, #8b4513)', // Richer wood texture
                                borderRadius: '2px',
                                transformOrigin: 'bottom center',
                                animation: 'hammerSwing 1.5s infinite',
                                zIndex: 2,
                            }, children: _jsx("div", { style: {
                                    position: 'absolute',
                                    top: '-12px',
                                    left: '-12px',
                                    width: '35px',
                                    height: '18px',
                                    background: 'linear-gradient(to bottom, #696969, #4a4a4a)', // Metallic hammer head
                                    borderRadius: '3px',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.5), inset 0 1px 2px rgba(255,255,255,0.2)', // Depth
                                } }) })] }), _jsx("div", { style: {
                        fontSize: '18px',
                        fontWeight: 'bold',
                        marginBottom: '5px',
                        color: '#112d61',
                    }, children: "F\u00F6rbereder din skylt..." }), _jsx("div", { style: { fontSize: '14px', color: '#112d61' }, children: "Karvar ut den perfekta designen f\u00F6r dig!" }), _jsx("style", { children: `
          @keyframes hammerSwing {
            0% { transform: rotate(-20deg); }
            25% { transform: rotate(-60deg); }
            30% { transform: rotate(5deg); }
            35% { transform: rotate(0deg); }
            100% { transform: rotate(-20deg); }
          }
          @keyframes tabletShake {
            0%, 10%, 30%, 100% { transform: translateX(0); }
            15% { transform: translateX(-3px) rotate(-2deg); }
            20% { transform: translateX(3px) rotate(2deg); }
            25% { transform: translateX(-1px) rotate(-1deg); }
          }
          @keyframes dustAppear {
            0%, 10%, 100% { opacity: 0; }
            15%, 40% { opacity: 1; }
          }
          @keyframes dustFloat1 {
            15% { transform: translate(0, 0); opacity: 1; }
            60% { transform: translate(8px, -10px); opacity: 0; }
          }
          @keyframes dustFloat2 {
            15% { transform: translate(0, 0); opacity: 1; }
            60% { transform: translate(10px, -5px); opacity: 0; }
          }
          @keyframes dustFloat3 {
            15% { transform: translate(0, 0); opacity: 1; }
            60% { transform: translate(-8px, -8px); opacity: 0; }
          }
          @keyframes sparkFloat1 {
            15% { transform: translate(0, 0); opacity: 1; }
            60% { transform: translate(5px, -15px); opacity: 0; }
          }
          @keyframes splashAppear {
            0%, 10%, 40%, 100% { opacity: 0; }
            15%, 25% { opacity: 1; }
          }
          @keyframes splashGrow {
            0% { transform: scale(0.2); opacity: 1; }
            100% { transform: scale(1); opacity: 0; }
          }
        ` })] }) }));
};
export default LoadingOverlay;
